import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=8e7969d0&"
import script from "./Sms.vue?vue&type=script&lang=js&"
export * from "./Sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e7969d0')) {
      api.createRecord('8e7969d0', component.options)
    } else {
      api.reload('8e7969d0', component.options)
    }
    module.hot.accept("./Sms.vue?vue&type=template&id=8e7969d0&", function () {
      api.rerender('8e7969d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Sms.vue"
export default component.exports